export class ListData {
    canAdd!: boolean;
    canEdit!: boolean;
    canDelete!: boolean;
    cancellationPolicies!: {
        pageData: {
            id: number
            name: string
            refundAmount: number
            beforeReservation: string
            // afterReservation: string
            isActive: boolean
        }[]
        pageIndex: number
        pageSize: number
        totalCount: number
    }
    exception!: {
        isActive: boolean
        reservationNumber: number
    }
    exceptionTags!: {
        isActive: boolean
        tags: []
    }
    noShowPolicies!: {
        isActive: boolean
        refundAmount: number
    }
}

export class Record {
    id!: string
    title_EN!: string
    title_AR!: string
    restaurantId!: number
    refund!: number
    beforeTime!: number
    beforeTimeType!: string
    // afterTime!: number
    // afterTimeType!: string
}

export class ShowPolicy {
    amount!: number
    restaurantId!: number
}

export class Reservation {
    reservationNumber!: number
    isActive!: number
}
export class ReservationType {
    name!: string
    value!: string
} []

export class ExceptionTags {
    id!: number
    name!: string
    isSelected!: boolean
}

export class ListFilter {
    pageNumber!: number
    pageSize!: number
    searchText!: string
    restaurantId!: number
}

export enum sortList {
    Name = 0,
    NewestCreate = 1,
    OldestCreate = 2,
    HighestUse = 3,
    LowestUse = 4
}

export enum policyType {
    CancellationPolicy = 'CancellationPolicy',
    No_Show = 'No_Show'
}

export enum exceptionType {
    ReservationNumber = 0,
    Tags = 1
}